module.exports = __webpack_public_path__ + "static/basicCostOfService_v2-87d3018ac3a4346a01da3c8e00ba8e88.png";